/**
 * Decorates a function with fluent flags that are then passed as an object.
 *
 * ```ts
 * const cb = FluentFlags<'foo' | 'bar'>(flags => (arg?: string) => [flags.foo, flags.bar, arg])
 * expect(cb()).toMatchObject([void 0, void 0, void 0])
 * expect(cb('hello')).toMatchObject([void 0, void 0, 'hello'])
 * expect(cb.bar('hello')).toMatchObject([void 0, true, 'hello'])
 * expect(cb.foo.bar('hello')).toMatchObject([true, true, 'hello'])
 * ```
 */ export const FluentFlags = (cb, flags = {})=>new Proxy(cb, {
        get (_, prop, receiver) {
            flags[prop] = true;
            return receiver;
        },
        apply (_, self, args) {
            const f = {
                ...flags
            };
            flags = {} // reset for next use
            ;
            return cb.call(self, f).apply(self, args);
        }
    })
;

//# sourceMappingURL=index.js.map